import { useTranslation } from 'react-i18next'
import { useSnackbar } from '@dhl/snackbar'
import { useTranslationContext } from '~/hooks'
import type { BusinessUnitCode } from '~/model'

export const useHandleReturnRequestError = (businessUnitCode: BusinessUnitCode) => {
  const { enqueueSnackbar } = useSnackbar()
  const { t, i18n } = useTranslation()
  const translationContext = useTranslationContext(businessUnitCode)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleReturnRequestError = (error: any, setFieldValue: (field: string, value: any) => void) => {
    const key = error.data?.key || ''
    const specificMessage = i18n.exists(`error.${key}`) ? t(`error.${key}`, translationContext) : ''
    const message = error.data?.message || ''
    const generalMessage = t('error.general_error')

    const errorMessage = specificMessage || message || generalMessage

    enqueueSnackbar(errorMessage, { variant: 'error' })

    // Reset the recaptcha
    window.grecaptcha.reset()
    setFieldValue('captcha', '')
  }

  return {
    handleReturnRequestError,
  }
}
